import { useState } from 'react';

function BrandFundamentals({ onComplete }) {
  const [formData, setFormData] = useState({
    usp: '',
    visionStatement: '',
    missionStatement: '',
    valuesAndBeliefs: '',
    emotionalBenefits: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onComplete(true);
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="flex items-center space-x-2 mb-6">
        <span className="text-green-500">✓</span>
        <h2 className="text-lg font-medium">Brand Fundamentals</h2>
      </div>
      <p className="text-sm text-gray-600 mb-6">
        Brand fundamentals establish the core elements that define a brand's unique identity, values, and competitive advantage.
      </p>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            USP (Unique Selling Proposition)
          </label>
          <textarea
            name="usp"
            value={formData.usp}
            onChange={handleChange}
            rows={4}
            placeholder="What is the unique selling proposition of the company's products?"
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Vision Statement
          </label>
          <textarea
            name="visionStatement"
            value={formData.visionStatement}
            onChange={handleChange}
            rows={4}
            placeholder="What is the vision of the company?"
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Mission Statement
          </label>
          <textarea
            name="missionStatement"
            value={formData.missionStatement}
            onChange={handleChange}
            rows={4}
            placeholder="What is the mission of the company?"
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Values and Beliefs
          </label>
          <textarea
            name="valuesAndBeliefs"
            value={formData.valuesAndBeliefs}
            onChange={handleChange}
            rows={4}
            placeholder="What are the core values and beliefs of the company?"
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Emotional Benefits
          </label>
          <textarea
            name="emotionalBenefits"
            value={formData.emotionalBenefits}
            onChange={handleChange}
            rows={4}
            placeholder="What are the emotional benefits that the company provides?"
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          />
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="px-4 py-2 bg-[#0049ac] text-white rounded-lg hover:bg-[#0049ac]/90"
          >
            Save & Continue
          </button>
        </div>
      </form>
    </div>
  );
}

export default BrandFundamentals;